import Swiper from 'swiper';

// ------------------------------------------------
//	スクロールアニメーション（.anim → .active）
//	fadeInUp / シャッター(img-wrap2) 共通トリガー
// ------------------------------------------------
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	if (document.readyState !== 'complete') {
		window.addEventListener('load', check, { once: true });
	}
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// ------------------------------------------------
//	KV: CSS純正の連続スクロール（.cm__kv-track / JS不要で動くためJSでの制御なし）
// ------------------------------------------------
// ------------------------------------------------
//	swiper（画像自動スライド）
// ------------------------------------------------
const funcSlider = () => {
	const el = document.querySelector('.cm__slider .swiper-container');
	if (!el) return;

	// 無限に左へ流れ続ける動きにはloop:trueが必須（loopなしのslideTo(0)は逆方向へ巻き戻るだけで一方向フローにならない）。
	// loopedSlidesは指定しない: slidesPerView:'auto'時、Swiper本体(loopCreate.js)が実スライド数(2)を自動採用する仕様のため、
	// 手動指定しても2にキャップされるだけで変化しない（ソース確認済み）。
	const swiper = new Swiper(el, {
		loop: true,
		slidesPerView: 'auto', // 幅240px固定（CSS側）で左揃え開始・次の画像が少し覗く
		spaceBetween: 14, // スライド間の余白はここ(JS)だけで指定。CSS側にmarginを重複させない
		speed: 600,
		allowTouchMove: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true, // マウスオン時はオートプレイを止める
		},
	});

	// 画像読み込み完了前の幅計測で初期位置がズレるケースに備え、全画像ロード後に再計算＋1枚目へ強制的に位置合わせ
	window.addEventListener('load', () => {
		swiper.update();
		swiper.slideToLoop(0, 0, false);
	});
};

// ------------------------------------------------
//	PC左ナビ：現在セクションをハイライト（該当=濃 / その他=薄）
// ------------------------------------------------
// fruitszipper踏襲: .area を IntersectionObserver で監視し、対応する <li> に is-current を付与
// （ナビの現在地ハイライトと fadeInUp の .active を別要素に分けることでクラス衝突を避ける）
const funcNav = () => {
	const areas = document.querySelectorAll('.area');
	const navItems = document.querySelectorAll('.side__nav li');
	if (!areas.length || !navItems.length) return;

	const areasArray = [...areas];
	const check = (entries) => {
		entries.forEach((entry) => {
			const index = areasArray.indexOf(entry.target);
			if (index === -1) return;

			if (entry.isIntersecting) {
				navItems.forEach((item) => item.classList.remove('is-current'));
				if (navItems[index]) navItems[index].classList.add('is-current');
			} else {
				if (navItems[index]) navItems[index].classList.remove('is-current');
			}
		});
	};

	const observer = new IntersectionObserver(check, {
		rootMargin: '0px 0px -90% 0px',
		threshold: 0,
	});
	areas.forEach((target) => observer.observe(target));
};

// ------------------------------------------------
//	スムーススクロール（.anchor）
// ------------------------------------------------
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);

const funcSmoothScroll = () => {
	const duration = 500;
	document.querySelectorAll('.anchor').forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;
			const target = document.getElementById(href.slice(1));
			if (!target) return;

			e.preventDefault();
			e.stopPropagation();

			const start = window.scrollY || 0;
			const dest = start + target.getBoundingClientRect().top;
			const dist = dest - start;
			const startTime = performance.now();

			const loop = (now) => {
				const nt = (now - startTime) / duration;
				if (nt < 1) {
					window.scrollTo(0, start + dist * easeInOut(nt));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, dest);
				}
			};
			requestAnimationFrame(loop);
		});
	});
};

window.addEventListener('DOMContentLoaded', () => {
	funcAnim();
	funcSlider();
	funcNav();
	funcSmoothScroll();
});
